import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import ServiceReportModal from "../../../components/dashboard/service/reports/service-report-edit-modal";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { useTranslation } from "react-i18next";
import CaseTypesStacklist from "../../../components/dashboard/cases/settings/case-types-stacklist";
import AutomaticCaseEmailSettings from "../../../components/dashboard/cases/settings/automatic-case-email-settings";

export const CaseSettings = (props) => {
  const { t } = useTranslation();
  const { ...other } = props;
  const [newServiceReportModalOpen, setNewServiceReportModalOpen] =
    useState(false);
  const dispatch = useDispatch();

  const [controller, setController] = useState({
    filters: [],
    page: 1,
    query: "",
    sort: "desc",
    sortBy: "updated_at",
    view: "all",
  });

  return (
    <>
      <DashboardHeader
        subtitle=""
        actions={[]}
        title={t("Case Settings")}
        meta={[]}
      >
        <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
            <div className="rounded-lg border border-emerald-100 bg-emerald-50 p-4 shadow-sm">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h3 className="text-base font-semibold text-slate-950">{t("Caseguider")}</h3>
                  <p className="mt-1 text-sm text-slate-600">{t("Opprett og rediger guidede flyter for saker på egen side.")}</p>
                </div>
                <Link
                  to="/dashboard/cases/settings/case-guides"
                  className="inline-flex items-center justify-center rounded-md bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700"
                >
                  {t("Åpne caseguider")}
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-5">
              <AutomaticCaseEmailSettings />
              <div className="grid grid-cols-1 max-sm:hidden"></div>
              <div className="grid grid-cols-2 max-sm:grid-cols-1  gap-5">
                <div className="grid-cols-1">
                  <CaseTypesStacklist />
                </div>
              </div>
            </div>
          </div>
        </div>
      </DashboardHeader>
      <ServiceReportModal
        onClose={() => setNewServiceReportModalOpen(false)}
        open={newServiceReportModalOpen}
        itemId={0}
      />
    </>
  );
};
